export default __webpack_public_path__ + "assets/models/41a35a3f4e93ede52ac7f911348255e5.glb";